module.exports = __webpack_public_path__ + "static/img/videoIcon.dc76970f.svg";